export function symbolOfRMB (data) {
  if (data) {
    // 使用正则表达式添加千位分隔符
    // data 传过来的都是number
    // console.log('RMB-千位分隔符 - 前', data)
    let decimalPointJudgment = hasTwoDecimalPlaces(data)
    if (decimalPointJudgment) {
      // true: 带2位小数点
      let formattedAmount = data
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // console.log('RMB-千位分隔符: -- 带2位小数点直接返回:', formattedAmount)
      return formattedAmount
    } else {
      // false: 不带2位小数点
      // console.log('~~~~~注意,非2位小数~~~', data)
      // let addZero = data.toFixed(2)
      // console.log('---------已经补0---------', addZero)

      // let formattedAmount = addZero
      //   .toString()
      //   .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // formattedAmount
      // console.log('RMB-千位分隔符: -- 不带2位小数点,须补0:', formattedAmount)
      // console.log('---------!数据格式---------', typeof formattedAmount)
      // return formattedAmount

      // 需求变更，金额统一保留整数
      let formattedAmount = data
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formattedAmount
    }
  } else {
    return data
  }
}
function hasTwoDecimalPlaces (number) {
  let regex = /^\d+\.\d{2}$/
  // console.log('判断传过来的数据是不是带2位小数', regex.test(number))
  return regex.test(number)
}

export function removeSymbolOfRMB (data) {
  if (data) {
    // 使用正则表达式去除千位分隔符
    // console.log(';;;', typeof data)
    let removeRMB = data.toString().replace(/,/g, '')
    // console.log('no-RMB', removeRMB)
    // return removeRMB
    return Number(removeRMB)
  }
}
